import { COVERAGE_TABS } from '../../../../constants';
import { TRACKING_SUB_AREA } from '../../../../trackingV2';
import { createCoverageParamsSelector, createCoverageSelector } from '../../../common/coverage/selectors';
import * as filtersSelectors from '../../filters/selectors';

export const getOSCoverage = (store) => store.apps.analytics.vdc.coverage.os;

export const osCoverageSelector = createCoverageSelector({
  coverageStore: getOSCoverage,
  source: 'vdc',
  productSubArea: TRACKING_SUB_AREA[COVERAGE_TABS.os.trackEvent],
});

export const getParams = createCoverageParamsSelector(
  filtersSelectors.getCoverageFiltersParams,
  getOSCoverage,
);
